/*
 * Copyright © 2026. Legalbird eine Marke der Legalbird GmbH
 */

import Accordion, { AccordionProps } from "@/src/components/Accordion/Accordion";
import Typography from "@mui/material/Typography";
import LinkLegalbird from "@/src/components/legalbird/LinkLegalbird/LinkLegalbird";
import { ArrowForward } from "@mui/icons-material";
import { areasOfLawAccordionContent } from "@/src/components/AreaOfLawAccordion/areasOfLawAccordionContent";
import { Box, SxProps, Theme } from "@mui/material";
import { mergeSx } from "@/src/utils/mergeSx";

export type AreaOfLawAccordionProps = { sxContent?: SxProps<Theme> } & Pick<AccordionProps, "sx" | "accordionId"> & (typeof areasOfLawAccordionContent)[0];

export default function AreaOfLawAccordion({ icon, title, text, link, sx, sxContent, accordionId }: AreaOfLawAccordionProps) {
  return (
    <Accordion
      key={title}
      icon={icon}
      title={title}
      accordionId={accordionId}
      sx={mergeSx((theme) => ({ backgroundColor: theme.palette.background.default }), sx)}
    >
      <Box sx={sxContent}>
        <Typography>{text}</Typography>
        <Box sx={{ marginTop: "0.5rem" }}>
          <LinkLegalbird to={link} standalone>
            Mehr erfahren <ArrowForward />
          </LinkLegalbird>
        </Box>
      </Box>
    </Accordion>
  );
}
